import { API_URL } from "../config/connect";

const getAuthHeaders = () => {
  const token = localStorage.getItem("google_id_token");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

const parseError = async (response, fallbackMessage) => {
  try {
    const data = await response.json();
    if (typeof data?.detail === "string") {
      return data.detail;
    }
    return fallbackMessage;
  } catch {
    return fallbackMessage;
  }
};

const createApiError = (status, message) => {
  const error = new Error(message);
  error.status = status;
  return error;
};

const request = async (url, options, fallbackMessage) => {
  const response = await fetch(url, options);
  if (!response.ok) {
    const message = await parseError(response, fallbackMessage);
    throw createApiError(response.status, message);
  }
  return response;
};

export const getBannerCandidates = async () => {
  const response = await request(
    `${API_URL}/api/v1/admin/banner/candidates`,
    {
      method: "GET",
      headers: getAuthHeaders(),
    },
    "Не удалось получить список баннеров пользователей"
  );
  return response.json();
};

export const activateUserBanner = async (userId) => {
  const response = await request(
    `${API_URL}/api/v1/admin/banner/activate`,
    {
      method: "PATCH",
      headers: getAuthHeaders(),
      body: JSON.stringify({ user_id: userId }),
    },
    "Не удалось активировать баннер"
  );
  return response.json();
};

export const deactivateCurrentBanner = async () => {
  const response = await request(
    `${API_URL}/api/v1/admin/banner/deactivate`,
    {
      method: "PATCH",
      headers: getAuthHeaders(),
    },
    "Не удалось деактивировать активный баннер"
  );
  return response.json();
};

export const getPublicBanner = async () => {
  const response = await request(
    `${API_URL}/api/v1/banner`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
    "Не удалось получить публичный баннер"
  );
  return response.json();
};
